import { useState } from 'react'
import { useEffect } from 'react'

const useStyle = (url) => {
  const [styleLoaded, setStyleLoaded] = useState(false)

  useEffect(() => {
    async function loadStyle(style) {
      document.head.appendChild(style)

      style.loaded = new Promise((resolve) => {
        style.onload = () => {
          resolve()
        }
      })

      await Promise.all([style.loaded])

      setStyleLoaded(true)
    }

    const style = document.createElement('link')

    style.href = url
    style.type = 'text/css'
    style.rel = 'stylesheet'

    loadStyle(style)

    return () => {
      document.head.removeChild(style)
    }
  }, [url])

  return [styleLoaded]
}

function Style({ src }) {
  useStyle(src)

  return null // Return null is necessary for the moment.
}

export { Style, useStyle }
